import React from 'react';
import PageLayout from '../components/layout/PageLayout';

const TermsOfService: React.FC = () => {
  return (
    <PageLayout>
      <div className="max-w-4xl mx-auto px-4 py-8">
        <h1 className="text-3xl font-bold text-gray-900 mb-6">Terms of Service</h1>
        
        <p className="text-sm text-gray-600 mb-8">
          <strong>Last Updated:</strong> December 20, 2025
        </p>

        <div className="space-y-6 text-gray-700">
          <section>
            <h2 className="text-2xl font-bold text-gray-900 mb-3">1. Acceptance of Terms</h2>
            <p>
              By accessing or using Ruchira's home food delivery platform, you agree to be bound by these 
              Terms of Service and our Privacy Policy. If you do not agree, please do not use our Service.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-gray-900 mb-3">2. Service Description</h2>
            <p>
              Ruchira is a platform connecting customers with home chefs who prepare and deliver homemade food. 
              We facilitate orders, payments, and deliveries but do not directly prepare or deliver food ourselves.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-gray-900 mb-3">3. User Accounts</h2>
            <p>You agree to:</p>
            <ul className="list-disc list-inside ml-4 mt-2 space-y-1">
              <li>Provide accurate and complete registration information</li>
              <li>Maintain the security of your account credentials</li>
              <li>Notify us immediately of any unauthorized access</li>
              <li>Be responsible for all activities under your account</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-gray-900 mb-3">4. Orders and Payment</h2>
            <p>
              All orders are subject to acceptance by the home chef. Prices are in Indian Rupees (INR) and 
              include applicable taxes. Payment must be completed before food preparation begins.
            </p>
            <p className="mt-2">
              We accept payment via wallet, UPI, and cash on delivery. Refunds are processed according to 
              our refund policy.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-gray-900 mb-3">5. Cancellation and Refunds</h2>
            <ul className="list-disc list-inside ml-4 mt-2 space-y-1">
              <li>Orders can be cancelled before chef acceptance</li>
              <li>Cancellation after acceptance may incur charges</li>
              <li>Refunds are processed within 5-7 business days</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-gray-900 mb-3">6. WhatsApp Communications</h2>
            <p>
              By providing your phone number, you consent to receive order-related notifications via WhatsApp. 
              You can opt-out at any time by replying "STOP" or updating your preferences.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-gray-900 mb-3">7. User Conduct</h2>
            <p>You agree not to:</p>
            <ul className="list-disc list-inside ml-4 mt-2 space-y-1">
              <li>Use the Service for illegal purposes</li>
              <li>Harass or abuse chefs, delivery partners, or staff</li>
              <li>Provide false or misleading information</li>
              <li>Attempt to circumvent security measures</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-gray-900 mb-3">8. Intellectual Property</h2>
            <p>
              All content, trademarks, and logos on Ruchira are the property of Xarvin or its licensors. 
              You may not use our intellectual property without prior written consent.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-gray-900 mb-3">9. Limitation of Liability</h2>
            <p>
              Ruchira is not liable for food quality, allergic reactions, or food-borne illnesses. Home chefs 
              are independent contractors responsible for food safety and quality.
            </p>
            <p className="mt-2">
              We are not responsible for delays or failures caused by circumstances beyond our control, including 
              but not limited to natural disasters, network failures, or third-party service interruptions.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-gray-900 mb-3">10. Indemnification</h2>
            <p>
              You agree to indemnify and hold Ruchira harmless from any claims, damages, or expenses arising 
              from your use of the Service or violation of these Terms.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-gray-900 mb-3">11. Dispute Resolution</h2>
            <p>
              Any disputes arising from these Terms shall be resolved through arbitration in Bengaluru, Karnataka, 
              in accordance with Indian arbitration laws.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-gray-900 mb-3">12. Termination</h2>
            <p>
              We reserve the right to suspend or terminate your account at any time for violation of these Terms 
              or for any other reason at our sole discretion.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-gray-900 mb-3">13. Changes to Terms</h2>
            <p>
              We may modify these Terms at any time. Continued use of the Service after changes constitutes 
              acceptance of the modified Terms.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-gray-900 mb-3">14. Contact</h2>
            <div className="bg-gray-50 p-4 rounded-lg">
              <p><strong>Email:</strong> support@ruchira.app</p>
              <p><strong>Legal:</strong> legal@ruchira.app</p>
              <p><strong>Website:</strong> https://ruchira.app</p>
            </div>
          </section>
        </div>

        {/* Footer */}
        <div className="mt-12 pt-6 border-t border-gray-200 text-center text-sm text-gray-600">
          <p>© 2025 Ruchira by Xarvin. All rights reserved.</p>
        </div>
      </div>
    </PageLayout>
  );
};

export default TermsOfService;
